// react
import { lazy } from 'react';

import MainLayout from 'layout/MainLayout';
import Loadable from 'components/Loadable';

const TopPage = Loadable(lazy(() => import('pages/Top')));
const Cart = Loadable(lazy(() => import('pages/Cart')));
const Maintenance = Loadable(lazy(() => import('pages/Maintenance')));
const CartSelect = Loadable(lazy(() => import('sections/cart/Select')));
const CartForm = Loadable(lazy(() => import('sections/cart/Form')));
const CartConfirm = Loadable(lazy(() => import('sections/cart/Confirm')));
const CartComplete = Loadable(lazy(() => import('sections/cart/Complete')));

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '',
      element: <TopPage />
    },
    {
      path: 'maintenance',
      element: <Maintenance />
    },
    {
      path: 'rental/ec',
      element: <Cart />,
      children: [
        {
          path: '',
          element: <CartSelect />
        },
        {
          path: 'form',
          element: <CartForm />
        },
        {
          path: 'confirm',
          element: <CartConfirm />
        },
        {
          path: 'complete',
          element: <CartComplete />
        }
      ]
    }
  ]
};

export default MainRoutes;
